var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ArgumentNullError } from "./errors";
export function parseCaddyData(data) {
    var isCaddy = data.isCaddy, other = __rest(data, ["isCaddy"]);
    return __assign(__assign({}, other), { caddyLaddersPitch: (data.caddyLaddersPitch && Number.parseFloat(data.caddyLaddersPitch)) || 0 });
}
export function parseShelfData(data) {
    return __assign(__assign({}, (data.isCaddy === true ? parseCaddyData(data) : data)), { isCaddy: data.isCaddy === true });
}
export function parseGroup(group) {
    var padding = (group.data && group.data.padding) || {};
    if (!group.data) {
        throw ArgumentNullError.fromName("data");
    }
    return __assign(__assign({}, group), { components: group.components.map(parseGroup), data: __assign(__assign({}, (group.type === "SHELF" ? parseShelfData(group.data) : group.data)), { padding: parsePadding(padding) }) });
}
export function parsePadding(padding) {
    return {
        top: (padding.top && Number.parseInt(padding.top, 10)) || 0,
        left: (padding.left && Number.parseInt(padding.left, 10)) || 0,
        right: (padding.right && Number.parseInt(padding.right, 10)) || 0,
        bottom: (padding.bottom && Number.parseInt(padding.bottom, 10)) || 0
    };
}
// TODO: move sephora test here
export function parseCluster(cluster) {
    return __assign(__assign({}, cluster), { config: __assign(__assign({}, cluster.config), { groups: cluster.config.groups.map(parseGroup) }) });
}



//////////////////
// WEBPACK FOOTER
// ../plano/dist/parse_cluster.js
// module id = 3441
// module chunks = 0